
import router from '@/router'
import { defineComponent } from 'vue'
import { useI18n } from 'vue-i18n'

export default defineComponent({
  props: {
    text: {
      type: String,
      default: 'buttons.volver'
    },
    goBack: {
      type: Object
    },
  },
  setup(props) {
    const { t } = useI18n()
    const { goBack } = props
    const handleBack = () => {
      if (goBack) {
        router.push(goBack)
      } else {
        router.go(-1)
      }
    }
    return {
      handleBack,
      t
    }
  }
})
